import React from "react";

const OfferLetter = ({ scoutName = "Scout", startDate = "", yourName = "" }) => {
  return (
    <div className="p-6 bg-white rounded shadow-md max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-4">Offer Letter</h2>
      <p className="mb-4">Dear {scoutName},</p>
      <p className="mb-4">
        We are pleased to offer you a place starting on <strong>{startDate}</strong>.
      </p>
      <p className="mb-4">Please let us know if you accept this offer.</p>
      <p className="mt-6">Sincerely,</p>
      <p className="font-medium">{yourName}</p>
    </div>
  );
};

export default OfferLetter;
